import Env from '../base/env.js'
import Channels from '../base/channels.js'
import gsap from 'gsap'

class MainnavTouch
{
    constructor()
    {
        if(Env.$mainNav == null) {
            return false
        }
        this.view = Env.$mainNav
        this.$triggers = Env.$body.querySelectorAll('.jsMainnav--trigger')
        this.$fill = this.view.querySelector('.fill')
        this.$primary = this.view.querySelector('.main-nav')
        // Flags
        this.IS_ANIMATING = false
        // Fns
        this.events()
    }
    events()
    {
        var
        self = this

        for ( const e of this.$triggers ) {
            e.addEventListener('click',()=>{
                if(this.IS_ANIMATING == false)
                {
                    this.toggle()
                }
                return false;
            },false)
        }

        Channels.on('mainnav::close',()=>
        {
            this.close()
        })

        Channels.on('window::smartresize',()=>{
            if(Env.mobileCSS === false)
            {
                // gsap.set(this.$primary,{ clearProps : 'opacity' })
                if(this.view != null) {
                    this.view.removeAttribute('style')
                }
            }
        })
    }

    getStatus()
    {
        return this.view.classList.contains('is--active')
    }

    close(funcStart=null,funcComplete=null)
    {
        this.out(
            ()=>{
                Channels.emit('mainnav::closing')
                this.IS_ANIMATING = true
                this.view.classList.remove('is--active');
                Env.$html.classList.remove('mainnav--isOpened')
                Env.$html.classList.add('mainnav--isLeaving')
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            ()=>{
                this.IS_ANIMATING = false
                Env.$html.classList.remove('mainnav--isLeaving')
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        )
    }

    in(funcStart='',funcComplete='')
    {

        let timeline = gsap.timeline({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'in'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
            gsap.fromTo(this.$fill , 1,
                {
                    x : '100%',
                    // opacity: 0
                },
                {
                    x: "0%",
                    // opacity: 1,
                    ease: 'power3.inOut',
                    delay: 0
                }
            ),
        ])
        timeline.add([
          gsap.fromTo(this.$primary , .8,
              {
                  opacity: 0,
              },
              {
                  opacity : 1,
                  ease: 'cubic.inOut',
                  delay: 0,
              },
          ),
        ],'-=.2')
    }

    out(funcStart='',funcComplete='')
    {

        let timeline = gsap.timeline({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'out'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
              gsap.to(this.$primary , .5,
                {
                    opacity : 0,
                    ease: 'cubic.out',
                    delay: 0,
                },
            ),
        ])
        timeline.add([
            gsap.to(this.$fill , .8,
                {
                    x: "-100%",
                    ease: 'power3.inOut',
                    delay: 0
                }
            ),
        ])

    }

    toggle(_status)
    {
        if (typeof _status === 'undefined')
            _status = this.view.classList.contains('is--active')

        if(!!_status)
        {
            this.close()
        }
        else
        {
            this.in(
                ()=>{
                    this.IS_ANIMATING = true
                    this.view.classList.add('is--active');
                    Env.$html.classList.add('mainnav--isOpened')
                },
                ()=>{

                    this.IS_ANIMATING = false
                }
            )
        }
    };
}

export default MainnavTouch;
